import { object, string } from 'yup';
import i18n from 'i18next';

export const schema = object().shape({
  radius: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  acceleration: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  braking: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  turning: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  speeding: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  accident: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  none: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_less_than_33_percentage: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_between_33_to_67_percentage: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_greater_than_67_percentage: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_accident: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_speeding: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_hard: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_harsh: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_severe: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
  severity_none: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .matches(/^[0-9]*$/, 'Must be a number'),
});
